/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import {useEffect, useState} from 'react';
import {APIGatewaySmartSearch, SmartSearchCriteria} from '@ion/core/src/types/services';

// Given a (CTC) smart search criteria, this hook builds & returns an API gateway compatible smart search.
export const useCreateAPISmartSearchCriteria = (
  criteria: SmartSearchCriteria,
  customSearch
): APIGatewaySmartSearch => {
  const [search, setSearch] = useState<APIGatewaySmartSearch>();

  useEffect(function(): void {
    if (!customSearch) {
      const smartSearch = criteria.searchCriteria[0]?.smartSearch;
      if (smartSearch) {
        const {
          accountId,
          ...rest
        } = smartSearch;
        setSearch({
          smartSearch : {
            search : {
              accountId : String(accountId),
              ...rest
            }
          }
        });
      }
    } else {
      setSearch(criteria);
    }
  }, [criteria]);

  return search;
};

export default useCreateAPISmartSearchCriteria;
